import React from "react";

import { Skeleton } from "antd";
import { createUseStyles } from "react-jss";

const FormSkeleton = () => {
  const styles = useStyles();
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",

        flexDirection: "column",
      }}
    >
      <Skeleton.Button active style={{ width: "40%", height: "45px" }} />
      <Skeleton.Button
        active
        style={{
          marginTop: 45,
          marginBottom: 12,
          height: "20px",
          width: "25%",
        }}
        paragraph={{ rows: 0 }}
      />
      <Skeleton.Input active style={{ width: "100%" }} />
      <Skeleton.Button
        active
        style={{
          marginTop: 45,
          marginBottom: 12,
          height: "20px",
          width: "25%",
        }}
        paragraph={{ rows: 0 }}
      />
      <Skeleton.Input active style={{ width: "100%" }} />
      <Skeleton.Button
        active
        style={{
          marginTop: 45,
          marginBottom: 12,
          height: "20px",
          width: "25%",
        }}
        paragraph={{ rows: 0 }}
      />
      <Skeleton.Input active style={{ width: "100%" }} />
      <span
        style={{
          marginTop: 45,
          display: "flex",
          alignSelf: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Skeleton.Input
          active
          style={{
            width: "30%",
            display: "flex",
            alignSelf: "center",
          }}
        />
      </span>
    </div>
  );
};

const useStyles = createUseStyles({
  card: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: 10,
    padding: 20,
    marginRight: 10,
  },
});

export default FormSkeleton;
